import { IconVan } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const logisticsModule: ModuleDefinition = {
  id: 'logistics',
  i18nNamespace: 'logistics',
  requires: { subject: 'shipment', action: 'read' },

  nav: {
    labelKey: 'logistics:nav',
    icon: IconVan,
    to: 'logistics',
    group: 'move',
    order: 20,
  },

  routes: [{ path: 'logistics', component: () => import('./LogisticsPage') }],

  commands: [
    {
      id: 'logistics.routes',
      labelKey: 'logistics:routes',
      groupKey: 'logistics:title',
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/logistics`),
    },
  ],
};
